import { isStudio } from '@modules/Core';

export const KEY = 'compsTitles';
export const STUDIO_EVENT_PARAM_KEY = 'pictureId';
export const MA_EVENT_PARAM_KEY = 'pictureId';
export const EXHIBITOR_EVENT_PARAM_KEY = 'evid';

export const EVENT_PARAM_KEY = isStudio() ? STUDIO_EVENT_PARAM_KEY : EXHIBITOR_EVENT_PARAM_KEY;
